import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon } from '../../../../atoms/material-icons';
import { BQLink } from '../../../../atoms/bqlink';
import EmptyState from '../empty-state';
import { useQuery } from 'react-query';
import { widgetLink } from '../../../../../helpers/utils';
import Loader from '../../../../atoms/icons/loader';
import './historical-returns-external-widget.m.css';

const HistoricalReturnsExternalWidget = ({ widget = false }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [historicalData, setHistoricalData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allIndicesTab, setAllIndicesTab] = useState(false);
  const [bseIndicesTab, setBseIndicesTab] = useState(false);
  const [nseIndicesTab, setNseIndicesTab] = useState(false);
  const [sectoralIndicesTab, setSectoralIndicesTab] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState('');

  const getHistoricalReturnsData = async (tab = 'all') => {
    const response = await fetch(`/feapi/markets/historical-returns/${tab}`);
    return response.json();
  };

  const resultHistoricalReturnsData = useQuery(
    'getHistoricalReturnsData',
    () => getHistoricalReturnsData(selectedIndex),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setHistoricalData(data.data);
      },
      enabled: !!selectedIndex,
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getHistoricalReturnsData = async () => {
      const response = await fetch('/feapi/markets/historical-returns/all');
      const data = await response.json();
      setHistoricalData(data?.data);
    };

    getHistoricalReturnsData();
  }, []);

  useEffect(() => {
    setSelectedIndex('all');
    if (resultHistoricalReturnsData?.isSuccess) {
      setHistoricalData(resultHistoricalReturnsData?.data?.data);
    }

    setAllIndicesTab(true);
    setBseIndicesTab(false);
    setNseIndicesTab(false);
    setSectoralIndicesTab(false);
  }, []);

  const indexChangeHandler = async (tab) => {
    setLoading(true);
    const response = await fetch(`/feapi/markets/historical-returns/${tab}`);
    const data = await response.json();
    setHistoricalData(data?.data);
    setLoading(false);
  };

  if (resultHistoricalReturnsData?.isLoading) {
    <div>
      <Loader color={'#dadee1'} />
    </div>;
  }

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="overall-container">
      <div styleName="header-container">
        <div styleName="icon-text-container">
          <BQLink href={widgetLink(`/markets${widgetParam}`, widget)} styleName="header-btn">
            <ChevronLeftIcon color="#8F9DA5" size={'25px'} />
          </BQLink>
          <h1 styleName="header-text">Historical Returns</h1>
        </div>

        <div styleName="btn-container">
          <button
            styleName={`indice-btn ${allIndicesTab ? 'selected' : ''}`}
            onClick={() => {
              indexChangeHandler('all');
              setSelectedIndex('all');
              setAllIndicesTab(true);
              setBseIndicesTab(false);
              setNseIndicesTab(false);
              setSectoralIndicesTab(false);
            }}
          >
            All Indices
          </button>
          <button
            styleName={`indice-btn ${bseIndicesTab ? 'selected' : ''}`}
            onClick={() => {
              indexChangeHandler('bse');
              setSelectedIndex('bse');
              setAllIndicesTab(false);
              setBseIndicesTab(true);
              setNseIndicesTab(false);
              setSectoralIndicesTab(false);
            }}
          >
            BSE Indices
          </button>
          <button
            styleName={`indice-btn ${nseIndicesTab ? 'selected' : ''}`}
            onClick={() => {
              indexChangeHandler('nse');
              setSelectedIndex('nse');
              setAllIndicesTab(false);
              setBseIndicesTab(false);
              setNseIndicesTab(true);
              setSectoralIndicesTab(false);
            }}
          >
            NSE Indices
          </button>
          <button
            styleName={`indice-btn ${sectoralIndicesTab ? 'selected' : ''}`}
            onClick={() => {
              indexChangeHandler('sectoral');
              setSelectedIndex('sectoral');
              setAllIndicesTab(false);
              setBseIndicesTab(false);
              setNseIndicesTab(false);
              setSectoralIndicesTab(true);
            }}
          >
            Sector Indices
          </button>
        </div>
      </div>

      <div styleName="content-container">
        <div styleName="table-container">
          {historicalData && historicalData?.length > 0 ? (
            <>
              {loading ? (
                <div styleName="no-data-container-ext">
                  <div styleName="no-data-container-int">
                    <Loader color={'#dadee1'} />
                  </div>
                </div>
              ) : (
                <>
                  {' '}
                  <div styleName="table-body-container">
                    <table styleName="main-table">
                      <thead styleName="table-header">
                        <tr>
                          <th styleName="column-title">#</th>
                          <th styleName="column-title">Indices</th>
                          <th styleName="column-title">1D</th>
                          <th styleName="column-title">1W</th>
                          <th styleName="column-title">1M</th>
                          <th styleName="column-title">3M</th>
                          <th styleName="column-title">6M</th>
                          <th styleName="column-title">YTD</th>
                          <th styleName="column-title">1Y</th>
                          <th styleName="column-title">2Y</th>
                          <th styleName="column-title">3Y</th>
                          <th styleName="column-title">4Y</th>
                          <th styleName="column-title">5Y</th>
                          <th styleName="column-title">10Y</th>
                        </tr>
                      </thead>
                      <tbody>
                        {historicalData &&
                          historicalData?.map((indiceValue, index) => (
                            <tr key={indiceValue?.id} styleName={`data-row `}>
                              <td styleName="name">{index + 1}</td>
                              <td styleName="name">{indiceValue.name ? indiceValue.name : '-'}</td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['1D']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['1D'] !== 'NA'
                                      ? `${indiceValue.returns['1D']}%`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['1D'] !== 'NA'
                                      ? `${indiceValue.returns['1D']}%`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['1W']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['1W'] !== 'NA'
                                      ? `${indiceValue.returns['1W']}%`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['1W'] !== 'NA'
                                      ? `${indiceValue.returns['1W']}%`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['1M']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['1M'] !== 'NA'
                                      ? `${indiceValue.returns['1M']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['1M'] !== 'NA'
                                      ? `${indiceValue.returns['1M']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['3M']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['3M'] !== 'NA'
                                      ? `${indiceValue.returns['3M']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['3M'] !== 'NA'
                                      ? `${indiceValue.returns['3M']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['6M']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['6M'] !== 'NA'
                                      ? `${indiceValue.returns['6M']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['6M'] !== 'NA'
                                      ? `${indiceValue.returns['6M']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns.YTD).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns.YTD !== 'NA'
                                      ? `${indiceValue.returns.YTD}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns.YTD !== 'NA'
                                      ? `${indiceValue.returns.YTD}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['1Y']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['1Y'] !== 'NA'
                                      ? `${indiceValue.returns['1Y']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['1Y'] !== 'NA'
                                      ? `${indiceValue.returns['1Y']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['2Y']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['2Y'] !== 'NA'
                                      ? `${indiceValue.returns['2Y']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['2Y'] !== 'NA'
                                      ? `${indiceValue.returns['2Y']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['3Y']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['3Y'] !== 'NA'
                                      ? `${indiceValue.returns['3Y']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['3Y'] !== 'NA'
                                      ? `${indiceValue.returns['3Y']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['4Y']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['4Y'] !== 'NA'
                                      ? `${indiceValue.returns['4Y']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['4Y'] !== 'NA'
                                      ? `${indiceValue.returns['4Y']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['5Y']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['5Y'] !== 'NA'
                                      ? `${indiceValue.returns['5Y']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['5Y'] !== 'NA'
                                      ? `${indiceValue.returns['5Y']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                              <td styleName="current-price">
                                {String(indiceValue.returns['10Y']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {indiceValue.returns['10Y'] !== 'NA'
                                      ? `${indiceValue.returns['10Y']}`
                                      : '-'}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {indiceValue.returns['10Y'] !== 'NA'
                                      ? `${indiceValue.returns['10Y']}`
                                      : '-'}
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div styleName="end-container"></div>
                </>
              )}
            </>
          ) : (
            <div styleName="no-data-container-ext">
              <div styleName="no-data-container-int">
                <EmptyState />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoricalReturnsExternalWidget;
